<app-lfsa-card [innTemplate]="reporte" [titulo]="titulo" [efecto]="true" [colapseName]="'reporte'" [banderaColapse]='true'>
</app-lfsa-card>
<ng-template #reporte>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <p>
          - Puede usar los filtros de canal, grupo de vendedor, vendedor. <br>
          - Cargar el presupuesto solo con los filtros de mes puede ocacionar demoras por el tamaño de la información
      </p>
      <hr>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbAnio"
          formControlName="anio" [control]="formulario.get('anio')" [label]="'Año*'" [id]="'anio'" (change)="searchAnioPresupuesto()">
        </app-lfsa-combo-box>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'detalle'" [idOpcion]="'id'"
            [comboBox]="versionesFiltrables" formControlName="version" [control]="formulario.get('version')"
            [label]="'Versión *'" [id]="'version'">
          </app-lfsa-combo-box>
      </div>
      
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoDeReporte"
          formControlName="tipoReporte" [control]="formulario.get('tipoReporte')" [label]="'Tipo de reporte*'" [id]="'tipoReporte'">
        </app-lfsa-combo-box>
      </div>
      
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoDePresupuesto"
          formControlName="tipoPresupuesto" [control]="formulario.get('tipoPresupuesto')" [label]="'Tipo de presupuesto*'" [id]="'tipoPresupuesto'">
        </app-lfsa-combo-box>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbPeriodo"
          formControlName="mesInicio" [control]="formulario.get('mesInicio')" [label]="'Desde*'" [id]="'mes'">
        </app-lfsa-combo-box>
      </div>
      
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbPeriodo"
          formControlName="mesFin" [control]="formulario.get('mesFin')" [label]="'Hasta*'" [id]="'mes'">
        </app-lfsa-combo-box>
      </div>

      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'nombreCanalVenta'" [idOpcion]="'codigoDireccion'" [comboBox]="cmbCanalVenta"
          formControlName="canal" [control]="formulario.get('canal')" [label]="'Canal Ventas'" [id]="'canal'">
        </app-lfsa-combo-box>
      </div>


      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasSuccess'" [opcion]="'dscaGrupoVendedor'" [idOpcion]="'idGrupoVendedor'" [comboBox]="cmbGrupoVendedor"
          formControlName="grupoVendedor" [control]="formulario.get('grupoVendedor')" [label]="'Grupo de Vendedores '" [id]="'grupoVendedor'" (change)="searchVendedor()">
        </app-lfsa-combo-box>
      </div>

      <!-- MODIFICACIONES PARA BORRADO EN MASA (change)="searchVendor()" -->
        <div [class]="'col-md-3'" *ngIf="filtrosEliminar || filtrosVendedor">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor'" [idOpcion]="'vendedor'" [comboBox]="cmbVendedorComision"
            formControlName="vendedorInicio" [control]="formulario.get('vendedorInicio')" [label]="'Vendedor Inicio'" [id]="'vendedorInicio'" (change)="searchVendor()">
          </app-lfsa-combo-box>
        </div>

        <div [class]="'col-md-3'" *ngIf="filtrosEliminar || filtrosVendedor">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreVendedor'" [idOpcion]="'vendedor'" [comboBox]="cmbVendedorComision"
            formControlName="vendedorFin" [control]="formulario.get('vendedorFin')" [label]="'Vendedor Fin'" [id]="'vendedorFin'" (change)="searchVendor()">
          </app-lfsa-combo-box>
        </div>

        <div [class]="'col-md-3'" *ngIf="filtrosEliminar" >
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreCliente'" [idOpcion]="'cliente'" [comboBox]="cmbClienteComision"
            formControlName="clienteInicio" [control]="formulario.get('clienteInicio')" [label]="'cliente Inicio'" [id]="'clienteInicio'" (change)="searchCliente()">
          </app-lfsa-combo-box>
        </div>

        <div [class]="'col-md-3'" *ngIf="filtrosEliminar">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombreCliente'" [idOpcion]="'cliente'" [comboBox]="cmbClienteComision"
            formControlName="clienteFin" [control]="formulario.get('clienteFin')" [label]="'cliente Fin'" [id]="'clienteFin'" (change)="searchCliente()">
          </app-lfsa-combo-box>
        </div>
      <!-- END -->
      
      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button [disabled]="this.formulario.invalid" (click)="getReport()" class="btn btn-success btn-block">
          <i class="fa fa-search"></i>Buscar</button>
      </div>
      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button [disabled]="this.rowData.length === 0" (click)="downloadDataCsv()" class="btn btn-success btn-block">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar Csv
        </button>
      </div>

      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button type="button" (click)="ngOnInit()" class="btn btn-success btn-block">Reiniciar Filtros de Reporte </button>
      </div>
      
      <div [class]="'col-md-3'">
        <label>&nbsp;</label>
        <button type="button" [disabled]="this.cmbVendedorComision.length === 0 || this.rowData.length === 0" (click)="habilitarFiltros()" class="btn btn-warning btn-block">Habilitar Filtros de Eliminación </button>
      </div>


      <div [class]="'col-md-3'" *ngIf="filtrosEliminar">
        <label>&nbsp;</label>
        <button [disabled]="this.rowData.length === 0" (click)="eliminarRegistros()" class="btn btn-danger btn-block">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>ELIMINAR
        </button>
      </div>

      <div [class]="'col-md-3'" *ngIf="filtrosEliminar">
        <label>&nbsp;</label>
        <button [disabled]="this.rowData.length === 0" (click)="refreshFiltroEliminacion()" class="btn btn-warning btn-block">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>Reiniciar Filtros de eliminación
        </button>
      </div>

    </div>
  </form>
  <hr>

  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Indicadores.
    </div>
    <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{modulo.agGrid.class}}"
      #agGridConsulta [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
      [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"  [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
      [paginationPageSize] = "modulo.agGrid.paginacion" >
    </ag-grid-angular>
  </div>
</ng-template>